import { render, staticRenderFns } from "./ServicesComponent.vue?vue&type=template&id=07a4938f&scoped=true"
import script from "./ServicesComponent.vue?vue&type=script&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./ServicesComponent.vue?vue&type=style&index=0&id=07a4938f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4938f",
  null
  
)

export default component.exports